module.exports = __webpack_public_path__ + "static/media/saumya.bc3e17a7.jpg";